import { forwardRef } from 'react';
import type { InputHTMLAttributes, ReactNode } from 'react';
import { cx } from '../lib/cx';

export interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: ReactNode;
}

/** On/off switch — a native checkbox with role="switch" under a sliding thumb. */
export const Switch = forwardRef<HTMLInputElement, SwitchProps>(function Switch(
  { label, className, disabled, ...rest },
  ref,
) {
  return (
    <label className={cx('tc-switch', disabled && 'tc-switch--disabled', className)}>
      <input ref={ref} type="checkbox" role="switch" className="tc-switch__native" disabled={disabled} {...rest} />
      <span className="tc-switch__track" aria-hidden>
        <span className="tc-switch__thumb" />
      </span>
      {label != null && <span className="tc-switch__label">{label}</span>}
    </label>
  );
});
